import React from 'react';
import './footer.css'

export default function Footer() {
    return(
        <div>
            <br/><br/><br/><br/><br/>
            <footer>
                <div className="foot">
                &copy;2021 Sahil Gupta
                </div>
            </footer>
        </div>
        
    );
}

